import React from 'react';
import { formatCurrencyInput, parseCurrencyInput } from '../utils/currency';

const CurrencyInput = ({ value, onValueChange, onChange, name, className = 'form-control', ...props }) => {
  const handleChange = (event) => {
    const numericValue = parseCurrencyInput(event.target.value);
    onValueChange?.(numericValue);
    onChange?.({ target: { name, value: numericValue, type: 'text' } });
  };

  return <input {...props} type="text" inputMode="numeric" name={name} className={className} value={formatCurrencyInput(value)} onChange={handleChange} />;
};

export default CurrencyInput;
